<template>
  <div class="my-warning">
    <span class="title">考核整改</span>
    <div class="my-warning-body">
      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <el-input
                size="small"
                placeholder="请输入企业名称关键字"
                prefix-icon="el-icon-search"
                v-model="searchParams.name"
              >
              </el-input>
            </div>
            <div class="input-li2">
              <span>辖区：</span>
              <el-select
                size="small"
                filterable
                clearable
                v-model="searchParams.jurisdiction"
                placeholder="请选择辖区"
              >
                <el-option
                  v-for="item in jurisdiction"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="search-action">
            <el-button
              size="small"
              icon="el-icon-search"
              type="primary"
              @click="getList()"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh"
              plain
              @click="onReset()"
              >重置</el-button
            >
          </div>
        </div>
      </div>

      <el-table
        size="small"
        height="calc(100% - 180px)"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <el-table
              size="small"
              height="calc(100% - 180px)"
              :header-cell-style="{
                background: '#f5f5f5',
              }"
              :data="row.examResults"
              style="width: 100%; margin-bottom: 20px"
              border
            >
              <el-table-column align="center" prop="date" label="日期">
              </el-table-column>
              <el-table-column align="center" label="考核情况">
                <el-table-column align="center" prop="fullMarks" label="满分">
                </el-table-column>
                <el-table-column align="center" prop="subMarks" label="扣分">
                </el-table-column>
                <el-table-column align="center" prop="addMarks" label="加分">
                  <template slot-scope="{ row }">
                    {{ "+" + row.addMarks }}
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="score" label="得分">
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" prop="examiner" label="考核人">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="企业名称">
        </el-table-column>
        <el-table-column align="center" prop="industry2017s" label="行业类别">
          <template slot-scope="{ row }">
            {{ row.industry2017s.map((d) => d.industryName).join("，") }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="wasteContact" label="联系人">
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="联系电话">
        </el-table-column>
        <el-table-column align="center" prop="score" label="最新考核结果（分）">
        </el-table-column>
      </el-table>

      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";

export default {
  components: {},
  data() {
    return {
      dataSource: [],
      searchParams: {
        name: "",
        type: "",
      },
      jurisdiction: [],
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
    };
  },
  computed: {},
  methods: {
    // add() {
    //   this.$refs.editService.lookDrawerOpen('新增');
    // },
    // edit(title, row) {
    //   this.$refs.editService.lookDrawerOpen(title, row.id);
    // },
    getParams() {
      const url = this.$api.exam.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction } = res.data.data;
          this.jurisdiction = jurisdiction;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getList() {
      const parames = {
        ...this.searchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.exam.getList;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { companies, total } = res.data.data;
          this.pagination.total = total;
          this.dataSource = companies;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.searchParams = {
        name: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getParams();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.my-warning {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .my-warning-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }

  .select-searchmain1 {
    width: 100%;
    // height: 70px;
    display: flex;
    padding: 5px 0px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      text-align: center;
      height: 100%;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      // padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }
}
</style> 